/**
 * Das Kopfbild der Homepage als Hintergrund - fuer Hauptmenue und Lobby
 * (15.10.2026). Ein Baustein, damit beide dasselbe Bild in derselben Fassung
 * laden; der Browser holt es dann nur einmal.
 *
 * Reine Kulisse: fuer Screenreader leer. Es blendet weich ein, sobald es
 * geladen ist; bis dahin steht der Bildschirm auf dunklem Grund.
 */

import { MENUE_HINTERGRUND } from './menueBilder.js';

export function MenueHintergrund() {
  return (
    <picture className="dl-menu__bild">
      <source type="image/avif" srcSet={MENUE_HINTERGRUND.avif} sizes="100vw" />
      <source type="image/webp" srcSet={MENUE_HINTERGRUND.webp} sizes="100vw" />
      <img
        src={MENUE_HINTERGRUND.ersatz}
        alt=""
        decoding="async"
        onLoad={(event) => event.currentTarget.classList.add('dl-menu__bild--da')}
      />
    </picture>
  );
}
